import React, { useRef, useState } from 'react';
import { createForm } from 'final-form';
import { Form } from 'react-final-form';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow
} from '@material-ui/core';
import { useNotify, useRedirect } from 'react-admin';
import FundInvestorSelection from './FundInvestorSelection';
import FundInvestorTagsAssociationsApi from '../../../../core/apis/FundInvestorTagsAssociationsApi';
import { getIcError } from '../../../../core/providers/utils';

const AssignTagForm = ({
  tagId,
  tagName,
  mapFundInvestors,
  initialFormValues,
  setShouldHideBackButton
}) => {
  const notify = useNotify();
  const redirect = useRedirect();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const rowsCount = mapFundInvestors.length;

  const handleChangePage = (_event, newPage) => setPage(newPage);

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const onSubmit = async formValues => {
    if (tagId) {
      let payloadTagAssociation = [];
      Object.entries(formValues).forEach(([fundId, associations]) => {
        Object.entries(associations).forEach(([investorId, value]) => {
          if (value === true) {
            payloadTagAssociation.push({
              fundInvestorTagId: tagId,
              fundInvestor: {
                fundId: fundId.slice(3),
                investorId: investorId.slice(3)
              }
            });
          }
        });
      });
      if (payloadTagAssociation.length > 0) {
        FundInvestorTagsAssociationsApi.create(payloadTagAssociation)
          .then(() => {
            notify('ra.notification.custom_updated_message');
            redirect(`/fundinvestortags/${tagId}`);
          })
          .catch(err => {
            notify('ra.notification.server', {
              type: 'warning',
              messageArgs: {
                message:
                  'Fund-Investor Tag has been created without associations. ' +
                  getIcError(err),
                isForkedWarning: true
              }
            });
          });
      } else {
        notify('ra.notification.created');
        redirect(`/fundinvestortags/${tagId}`);
      }
    }
  };

  const formRef = useRef(
    createForm({
      onSubmit: onSubmit,
      initialValues: initialFormValues
    })
  );

  return (
    <>
      <Form form={formRef.current}>
        {({ handleSubmit, values }) => (
          <form onSubmit={handleSubmit} id="formTagRelationship" noValidate>
            <Paper>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Funds</TableCell>
                    <TableCell>{tagName}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {mapFundInvestors
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map(([fundId, { fundName, investors }]) => (
                      <FundInvestorSelection
                        key={fundId}
                        fundName={fundName}
                        fundId={fundId}
                        investors={investors}
                        formValues={values}
                        formRef={formRef.current}
                        setShouldHideBackButton={setShouldHideBackButton}
                      />
                    ))}
                </TableBody>
              </Table>
            </Paper>
          </form>
        )}
      </Form>
      <TablePagination
        component="div"
        count={rowsCount}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[25, 50, 100]}
      />
    </>
  );
};
export default AssignTagForm;
